import React from "react";
import PropTypes from "prop-types";
import {useSelector} from "react-redux";
import Fallback from "./Fallback";
import {getUserProfile} from "../../redux/Selectors/users.selector";

/** This component checks if user has permission to view content.
 * If user has permission to view the content then content will be rendered,
 * other wise content will not be rendered
 */

const ProtectedContent = (props) => {
  const {
    children,
    perms: requiredPermissions = [],
    shouldHaveAllPermissions = true,
    showFallback = false,
  } = props;
  const user = useSelector(getUserProfile);
  const {user_permissions: userPermissions = []} = user;

  let showContent = false;

  if (shouldHaveAllPermissions) {
    // Show content if the user has all of the permissions passed as props
    showContent = requiredPermissions?.every((requiredPerm) =>
      userPermissions?.some((userPerm) => userPerm.value === requiredPerm)
    );
  } else {
    // Show content if the user has any of the permissions passed as props
    showContent = requiredPermissions?.some((requiredPerm) =>
      userPermissions?.some((userPerm) => userPerm.value === requiredPerm)
    );
  }
  if (requiredPermissions?.length === 0) {
    showContent = true;
  }

  // Either render the protected content or an alterative for unauthorized users
  return showContent ? <>{children}</> : showFallback ? <Fallback /> : null;
};

ProtectedContent.propTypes = {
  children: PropTypes.node,
  /** this prop determines which all permission are need to view the content.
   * by default this prop is set to empty array.
   * if this prop is set to empty array content will be rendered
   */
  perms: PropTypes.array,
  /** if this prop is set to true then content will be rendered if user has all the permissions required.
   * if this prop is set to false content will be rendered if user user has one of the permissions.
   */
  shouldHaveAllPermissions: PropTypes.bool,
  /** if this prop is set to true then fallback ui will be displayed */
  showFallback: PropTypes.bool,
};

export default ProtectedContent;
